import { gql } from "@apollo/client";

export const contactCreate = gql`
  mutation contactCreate($data: ContactCreateInput!) {
    contactCreate(data: $data) {
      id
    }
  }
`;
export const contactsList = gql`
  query contactsList($filter: ContactFilter, $sort: [ContactSort!]) {
    contactsList(filter: $filter, sort: $sort) {
      items {
        id
        first_name
        last_name
        email
        mobile
        home_address_one
        home_address_two
        home_city
        home_state
        home_zip_code
        mailing_address_one
        mailing_address_two
        mailing_city
        mailing_state
        mailing_zip
        preferred_contact_method
        updatedAt
        owner {
          id
          status
          email
          origin
          firstName
        }
      }
    }
  }
`;

export const contactUpdate = gql`
  mutation contactUpdate($data: ContactUpdateInput!) {
    contactUpdate(data: $data) {
      id
    }
  }
`;

export const contactDelete = gql`
  mutation contactDelete($data: ContactDeleteInput) {
    contactDelete(data: $data) {
      success
    }
  }
`;

export const phasesList = gql`
  query phasesList($filter: PhaseFilter) {
    phasesList(filter: $filter, sort: { order: ASC }) {
      items {
        id
        stage
        order
        type
        allowedStages
      }
    }
  }
`;

export const contactDetails = gql`
  query contact($id: ID) {
    contact(id: $id) {
      id
      email
      last_name
      first_name
      mobile
      mailchimp_synced
      phase {
        id
        stage
        order
        status
      }
      leadinfoloans {
        items {
          id
        }
      }
      portal_user_account {
        id
        email
      }
      home_address_one
      home_address_two
      home_city
      home_state
      home_zip_code
      mailing_address_one
      mailing_address_two
      mailing_city
      mailing_state
      mailing_zip
      preferred_contact_method
      type
      lead_source
      lead_company
      credit_score
      date_of_birth
      job_title
      loan_officer {
        id
        status
        email
        origin
        firstName
        lastName
      }
      industry
      employer
      client_care {
        id
        status
        email
        origin
        firstName
        lastName
      }
      monthly_income
      listings_manager {
        id
        status
        email
        origin
        firstName
        lastName
      }
      photographer {
        id
        status
        email
        origin
        firstName
        lastName
      }
      real_estate_agent {
        id
        status
        email
        origin
        firstName
        lastName
      }
      transaction_coordinator {
        id
        status
        email
        origin
        firstName
        lastName
      }
      processor {
        id
        status
        email
        origin
        firstName
        lastName
      }
      opportunityBuyings {
        items {
          id
          createdAt
          bedrooms
          bathrooms

          cities_searching
          ideal_move_in_date
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          transationBuyings {
            items {
              id
              home_inspection_date
              appraisal_date
              commission
              close_date
              broker_fee
              occupancy_date
              createdBy {
                id
                firstName
                lastName
              }
              phase {
                id
                stage
                order
                status
              }
              purchase_price
              concessions
              deposit
              opp_id
              financing_or_cash
              phaseId
              opp_id
              createdAt
            }
          }
          financing_type

          loan_officer
          down_payment_amount
          ideal_payment
          max_payment

          tours
          homes_seen
          offers_made
          broker_agreement_date
          first_showing_date
          first_offer_date
          square_feet
          opp_id
          owner {
            items {
              id
              email
              first_name
              last_name
            }
          }
        }
      }
      opportunityLeaseListings {
        items {
          id
          createdAt
          list_price_estimate
          subject_square_feet
          subject_bedrooms
          subject_bathrooms
          rental_rate_estimate_low
          rental_rate_estimate_high
          application_fee
          application_fee_currency
          lock_box_code
          showings_received
          offers_received
          total_listing_commission
          listing_agent_commission_percentage
          listing_agent_commission_currency
          broker_fee
          buyer_agent_commision_percentage
          buyer_agent_commision_currency
          total_listing_revenue
          total_revenue
          sign_ordered_date
          sign_up_date
          listing_active_date
          first_open_house
          second_open_house
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          transactionLeaseListings {
            items {
              createdBy {
                id
                firstName
                lastName
              }
              phase {
                id
                stage
                order
                status
              }
              id
              sale_price
              listing_expiration_date
              move_in_date
              seller_agent_commission
              broker_fee
              phaseId
              ownerId
              opp_id
              createdAt
              subject_city
            }
          }
          original_list_price
          list_date
          open_house_date
          listing_contract_signed_date
          photography_date
          staging_date
          listing_expiration_date
          first_offer_date
          ending_list_price
          ideal_move_out_date
          subject_city
          subject_state
          subject_zip_code
          subject_square_feet
          subject_bedrooms
          subject_bathrooms
          subject_waterfront
          subject_county
          subject_cma_value_low
          subject_cma_value_high

          opp_id
          owner {
            items {
              id
              email
              first_name
              last_name
            }
          }
        }
      }
      opportunityLeaseRenters {
        items {
          id
          desired_lease_term
          owner {
            items {
              id
              email
              first_name
              last_name
            }
          }
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          transactionLeaseRenters {
            items {
              id

              closed_date
              createdAt
              opp_id
              createdBy {
                id
                firstName
                lastName
              }
              phase {
                id
                stage
                order
                status
              }

              close_date
              commission
              security_deposit
              broker_fee

              lease_term
              deposit
            }
          }
          timeframe
          cities_searching
          ideal_move_in_date
          ideal_payment
          max_payment
          square_feet
          bedrooms
          bathrooms
          waterfront
          broker_agreement_date
          first_showing_date
          first_offer_date
          opp_id
        }
      }
      opportunitySellings {
        items {
          id
          createdAt
          subject_square_feet
          timeframe_to_list
          subject_cma_value_low
          subject_cma_value_high
          subject_bedrooms
          subject_bathrooms
          subject_waterfront
          ideal_move_out_date
          list_price_estimate

          owner {
            items {
              id
              email
              first_name
              last_name
            }
          }
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          transactionSellings {
            items {
              id
              title_company
              createdAt
              commission
              broker_fee
              commission
              home_inspection_date
              sale_price
              contract_close_date
              occupancy_days_allowed
              seller_agent_commission
              occupancy_end_date
              broker_fee
              appraisal_date
              opp_id
              createdBy {
                id
                firstName
                lastName
              }
              phase {
                id
                stage
                order
                status
              }
            }
          }
          ideal_move_out_date
          expired_date
          first_offer_date
          staging_date
          photography_date
          listing_contract_signed_date
          net_proceeds
          prorated_hoa_dues
          prorated_taxes

          subject_city
          subject_state
          subject_zip_code
          opportunity_id
          original_list_price
          list_date
          open_house_date
          ending_list_price
          listing_expiration_date
          timeframe_to_list
          title_company
          broker_fee
          commission_rate
          showings_received
          offers_received
          county
          buyer_agent_commission
          seller_agent_commission
          seller_closing_costs
          mortgage_payoff
          second_mortgage_payoff
          opp_id
        }
      }
      tags {
        items {
          id
          tag_name
        }
      }
      owner {
        id
        status
        email
        origin
        firstName
        lastName
      }
      leadInfoBuying {
        items {
          appointment_date
          appointment_scheduled_date
          bathrooms
          bedrooms
          cities_searching
          down_payment_amount
          financing_type
          id

          ideal_move_in_date
          ideal_payment
          lending_company
          loan_officer

          max_payment
          square_feet
          pre_approval_status
          waterfront
          garage
          basement
          notes
          loan_officer_phone
          loan_officer_email
          down_payment_percentage
          ideal_purchase_price
          max_purchase_price
          broker_agreement_date
          first_tour_date
          first_offer_date
        }
      }
      leadInfoLeaseListing {
        items {
          appointment_date
          appointment_scheduled
          id
          ideal_move_out_date
          list_price_estimate
          rental_rate_estimate_high
          rental_rate_estimate_low
          subject_bathrooms
          subject_bedrooms
          subject_city
          subject_cma_value_high
          subject_cma_value_low
          subject_county
          subject_address_one
          subject_address_two
          subject_square_feet
          subject_state
          subject_waterfront
          subject_zip_code
          subject_garage
          subject_basement
        }
      }
      leadInfoLeaseRenter {
        items {
          appointment_date
          appointment_scheduled_date
          bathrooms
          bedrooms
          cities_searching
          credit_score
          desired_lease_term
          id
          ideal_move_in_date
          ideal_payment
          ideal_lease_length
          max_lease_length
          max_payment
          monthly_income
          square_feet
          timeframe
          waterfront
          r_garage
          r_basement
          r_notes
        }
      }
      leadInfoSelling {
        items {
          appointment_date
          appointment_scheduled
          id
          ideal_move_out_date
          list_price_estimate
          subject_address_one
          subject_address_two
          subject_bedrooms
          subject_bathrooms
          subject_city
          subject_cma_value_high
          subject_cma_value_low
          subject_county
          subject_square_feet
          subject_state
          subject_waterfront
          subject_zip_code
          subject_garage
          subject_basement
        }
      }
      transationBuying {
        items {
          id
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          createdAt
          purchase_price
          concessions
          deposit
          financing_or_cash
          opportunityBuyingId
          home_inspection_date
          opp_id
          owner {
            id
            first_name
            last_name
          }
        }
      }
      transactionSellings {
        items {
          id
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          title_company
          commission
          broker_fee
          commission_rate
          opportunitySellingId
          opp_id
          owner {
            id
            first_name
            last_name
          }
        }
      }
      transactionLeaseRenters {
        items {
          id
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          createdAt

          opportunityLeaseRenterId
          opp_id
          owner {
            id
            first_name
            last_name
          }
        }
      }
      transactionLeaseListings {
        items {
          id
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          createdAt
          opp_id
          sale_price
          owner {
            id
            first_name
            last_name
          }
          listing_expiration_date
          under_contract_date
          keys_exchanged_date
          opportunityLeaseListingId
        }
      }
    }
  }
`;

export const activityCreate = gql`
  mutation activityCreate($data: ActivityCreateInput!) {
    activityCreate(data: $data) {
      id
      interation_type
      date
      description
    }
  }
`;

export const activitiesList = gql`
  query activitiesList($filter: ActivityFilter) {
    activitiesList(filter: $filter) {
      items {
        id
        interation_type
        date
        description
        subject
      }
    }
  }
`;

export const transactionsList = gql`
  query transactionsList($filter: TransactionFilter) {
    transactionsList(filter: $filter) {
      items {
        id
        dueDate
        transactionName
        type
        stage
        owner {
          id
          email
          status
          firstName
          lastName
        }
      }
    }
  }
`;

export const transactionsDetailsList = gql`
  query transactionsList($id: IDPredicate) {
    transactionsList(filter: { id: $id }) {
      items {
        id
        dueDate
        transactionName
        type
        stage
        owner {
          id
          email
          status
          firstName
          lastName
        }
        contacts {
          id
        }
      }
    }
  }
`;

export const taskDetails = gql`
  query task($id: ID) {
    task(id: $id) {
      id
      task_name
      due_date
      status
      assignee {
        id
        email
        firstName
      }
    }
  }
`;

export const transactionCreate = gql`
  mutation transactionCreate($data: TransactionCreateInput!) {
    transactionCreate(data: $data) {
      id
      dueDate
      transactionName
      type
      stage
    }
  }
`;

export const taskCreate = gql`
  mutation taskCreate($data: TaskCreateInput!) {
    taskCreate(data: $data) {
      id
      task_name
      due_date
      status
    }
  }
`;

export const tasksList = gql`
  query tasksList($filter: TaskFilter) {
    tasksList(filter: $filter) {
      items {
        id
        task_name
        type
        due_date
        status
        doc_type {
          id
          doc_name
          __typename
        }
        internalUserRole {
          id
          name
          __typename
        }
        users {
          id
          email
          lastName
          firstName
          __typename
        }
        attachments {
          id
          downloadUrl
          filename
          fileId
          __typename
        }
        contacts {
          id
          email
          first_name
          last_name
          mobile
          __typename
        }
        assignment_type
        opportunityBuying {
          id
          opp_id
          transactionCoordinatorId
          listingsManagerId
          clientCareId
          photographerId
          realEstateAgentId
          __typename
        }
        opportunitySelling {
          id
          opp_id
          realEstateAgent {
            id
            firstName
            lastName
          }
          transactionCoordinator {
            id
            firstName
            lastName
          }
          listingsManager {
            id
            firstName
            lastName
          }
          clientCare {
            id
            firstName
            lastName
          }
          photographer {
            id
            firstName
            lastName
          }
          listingsManagerId
          clientCareId
          photographerId
          transactionCoordinatorId
          realEstateAgentId
          __typename
        }
        opportunityLeaseRenter {
          id
          opp_id
          transactionCoordinatorId
          listingsManagerId
          clientCareId
          photographerId
          realEstateAgentId
          __typename
        }
        opportunityLeaseListing {
          id
          opp_id
          transactionCoordinatorId
          listingsManagerId
          clientCareId
          photographerId
          realEstateAgentId
          __typename
        }
        transactionBuying {
          id
          opp_id
          __typename
        }
        transactionSelling {
          id
          opp_id
          __typename
        }
        transactionLeaseRenter {
          id
          opp_id
          __typename
        }
        transactionLeaseListing {
          id
          opp_id
          __typename
        }
        loans {
          id
          auto_inc
          type
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const notesList = gql`
  query notesList($filter: NoteFilter) {
    notesList(filter: $filter) {
      items {
        id
        note_title
        description
        date
        author {
          id
          email
          status
          firstName
          lastName
        }
      }
    }
  }
`;

export const noteCreate = gql`
  mutation noteCreate($data: NoteCreateInput!) {
    noteCreate(data: $data) {
      id
      note_title
      description
      date
    }
  }
`;

export const noteDelete = gql`
  mutation noteDelete($id: ID) {
    noteDelete(data: { id: $id }) {
      success
    }
  }
`;

export const noteUpdate = gql`
  mutation noteUpdate($data: NoteUpdateInput!) {
    noteUpdate(data: $data) {
      note_title
      date
      description
    }
  }
`;

export const activityUpdate = gql`
  mutation activityUpdate($data: ActivityUpdateInput!) {
    activityUpdate(data: $data) {
      id
      interation_type
      date
    }
  }
`;

export const activityDelete = gql`
  mutation activityDelete($id: ID) {
    activityDelete(data: { id: $id }) {
      success
    }
  }
`;

export const transactionUpdate = gql`
  mutation transactionUpdate($data: TransactionUpdateInput!) {
    transactionUpdate(data: $data) {
      id
      dueDate
      transactionName
    }
  }
`;

export const transactionDelete = gql`
  mutation transactionDelete($id: ID) {
    transactionDelete(data: { id: $id }) {
      success
    }
  }
`;

export const taskUpdate = gql`
  mutation taskUpdate($data: TaskUpdateInput!) {
    taskUpdate(data: $data) {
      id
      task_name
      due_date
    }
  }
`;

export const taskDelete = gql`
  mutation taskDelete($id: ID) {
    taskDelete(data: { id: $id }) {
      success
    }
  }
`;

export const contactTypeUpdate = gql`
  mutation contactTypeUpdate($data: ContactUpdateInput!) {
    contactUpdate(data: $data) {
      id
      type
    }
  }
`;

export const usersList = gql`
  query usersList {
    usersList {
      items {
        id
        email
        status
        origin
        firstName
        lastName
      }
    }
  }
`;

export const tagsList = gql`
  query tagsList {
    tagsList {
      items {
        id
        tag_name
        tenants {
          id
          company_name
        }
        mailchimp_tag
      }
    }
  }
`;

export const tagCreate = gql`
  mutation tagCreate($data: TagCreateInput!) {
    tagCreate(data: $data) {
      id
    }
  }
`;

export const tagUpdate = gql`
  mutation tagUpdate($data: TagUpdateInput!) {
    tagUpdate(data: $data) {
      id
    }
  }
`;

export const tagDelete = gql`
  mutation tagDelete($data: TagDeleteInput) {
    tagDelete(data: $data) {
      success
    }
  }
`;

export const sendMailFromOutlook = gql`
  mutation sendMailFromOutlook($input: Payload) {
    sendMailFromOutlook(input: $input) {
      result
    }
  }
`;

export const sendMailFromGoogle = gql`
  mutation sendMailFromGoogle($input: Payload) {
    sendMailFromGoogle(input: $input) {
      result
    }
  }
`;

export const userUpdate = gql`
  mutation userUpdate($data: UserUpdateInput!) {
    userUpdate(data: $data) {
      id
      meta_data
    }
  }
`;

export const opportunityBuyingCreate = gql`
  mutation opportunityBuyingCreate($data: OpportunityBuyingCreateInput!) {
    opportunityBuyingCreate(data: $data) {
      id
    }
  }
`;

export const opportunitySellingCreate = gql`
  mutation opportunitySellingCreate($data: OpportunitySellingCreateInput!) {
    opportunitySellingCreate(data: $data) {
      id
    }
  }
`;

export const opportunityLeaseRenterCreate = gql`
  mutation opportunityLeaseRenterCreate(
    $data: OpportunityLeaseRenterCreateInput!
  ) {
    opportunityLeaseRenterCreate(data: $data) {
      id
    }
  }
`;

export const opportunityLeaseListingCreate = gql`
  mutation opportunityLeaseListingCreate(
    $data: OpportunityLeaseListingCreateInput!
  ) {
    opportunityLeaseListingCreate(data: $data) {
      id
    }
  }
`;

export const mtgPurchaseOppCreate = gql`
  mutation mtgPurchaseOppCreate($data: MtgPurchaseOppCreateInput!) {
    mtgPurchaseOppCreate(data: $data) {
      id
    }
  }
`;

export const mtgRefinanceOppCreate = gql`
  mutation mtgRefinanceOppCreate($data: MtgRefinanceOppCreateInput!) {
    mtgRefinanceOppCreate(data: $data) {
      id
    }
  }
`;

export const mtgHELOCOppCreate = gql`
  mutation mtgHELOCOppCreate($data: MtgHELOCOppCreateInput!) {
    mtgHELOCOppCreate(data: $data) {
      id
    }
  }
`;

export const mortgageTransactionCreate = gql`
  mutation mortgageTransactionCreate($data: MortgageTransactionCreateInput!) {
    mortgageTransactionCreate(data: $data) {
      id
    }
  }
`;

export const transactionBuyingUpdate = gql`
  mutation transactionBuyingUpdate($data: TransactionBuyingUpdateInput!) {
    transactionBuyingUpdate(data: $data) {
      id
    }
  }
`;
export const transactionSellingUpdate = gql`
  mutation transactionSellingUpdate($data: TransactionSellingUpdateInput!) {
    transactionSellingUpdate(data: $data) {
      id
    }
  }
`;
export const transactionLeaseRenterUpdate = gql`
  mutation transactionLeaseRenterUpdate(
    $data: TransactionLeaseRenterUpdateInput!
  ) {
    transactionLeaseRenterUpdate(data: $data) {
      id
    }
  }
`;
export const transactionLeaseListingUpdate = gql`
  mutation transactionLeaseListingUpdate(
    $data: TransactionLeaseListingUpdateInput!
  ) {
    transactionLeaseListingUpdate(data: $data) {
      id
    }
  }
`;

export const transactionBuying = gql`
  query transactionBuying($id: ID) {
    transactionBuying(id: $id) {
      id
      createdAt
      subject_address_one
      subject_address_two
      subject_city
      subject_state
      subject_zip_code
      subject_square_feet
      subject_county
      subject_bedrooms
      subject_bathrooms
      subject_garage
      subject_waterfront
      subject_basement
      inspection_status
      appraisal_status
      loan_status
      loan_amount
      appraised_value
      appraisal_date
      broker_fee
      buyer_agent_commission_parcentage
      buyer_agent_commission
      buyer_rebate
      central_air_age
      central_air_model
      close_date
      closed_date
      concessions
      deposit
      dishwasher_age
      dishwasher_model
      dryer_age
      dryer_model
      estimated_closed_date
      deposit_due_date
      deposit_received_date
      final_walkthtrough_date
      financing_or_cash
      financing_type
      furnace_age
      furnace_filter_size
      furnace_model
      home_inspection_date
      hot_water_age
      hot_water_model
      interest_rate
      loan_payment_pitimo
      principal_interest_mo
      property_taxes_mo
      insurance_mo
      mortgage_insurance_mo
      appraised_value_loan
      down_payment_parcentage_loanInfo
      down_payment_loanInfo
      keys_exchanged_date
      loan_down_payment
      loan_term
      mutual_release_date
      occupancy_date
      occupancy_days_allowed
      occupancy_end_date
      opp_id
      opportunityBuyingId
      ownerId
      purchase_price
      range_age
      range_model
      refridgerator_age
      refridgerator_model
      roof_age
      roof_type
      rebate
      septic_tank_age
      sump_pump_age
      sump_pump_model
      sump_pump_back_up
      total_revenue
      under_contract_date
      updatedAt
      washer_age
      washer_model
      water_softener_age
      water_softener_model
      phase {
        id
        stage
        order
        type
      }
      owner {
        id
        first_name
        last_name
        mobile
        email
      }
      opportunityBuying {
        id
        createdAt
        opp_id
        square_feet
        financing_type
        bathrooms
        bedrooms
        ideal_move_in_date
        down_payment_amount
        phase {
          id
          stage
          type
        }
        createdBy {
          id
          lastName
          firstName
        }
      }
      realEstateAgent {
        firstName
        lastName
        id
        email
      }
      clientCare {
        firstName
        lastName
        id
        email
      }
      photographer {
        firstName
        lastName
        id
        email
      }
      listingsManager {
        firstName
        lastName
        id
        email
      }
      transactionCoordinator {
        firstName
        lastName
        id
        email
      }
    }
  }
`;

export const transactionSelling = gql`
  query transactionSelling($id: ID) {
    transactionSelling(id: $id) {
      id
      actual_closing_date
      owner {
        id
        first_name
        last_name
        mobile
        email
      }
      subject_address_one
      subject_address_two
      subject_city
      subject_state
      subject_zip_code
      subject_county
      subject_square_feet
      subject_bedrooms
      subject_bathrooms
      subject_garage
      subject_basement
      subject_waterfront
      cash_sale
      inspection_status
      appraisal_status
      loan_status
      concessions
      appraisal_date
      broker_fee
      buyer_agent_commission
      closing_location
      closing_time
      c_commission_total
      c_listing_agent_commission_percentage
      c_listing_agent_commission_currency
      c_buyer_agent_commision_percentage
      c_buyer_agent_commision_currency
      c_total_listing_revenue
      c_total_revenue
      appointment_scheduled_date
      appointment_date
      sign_ordered_date
      sign_up_date
      listing_active_date
      first_open_house
      second_open_house
      k_lease_signing_date
      k_lease_start_date
      k_lease_expiration_date
      estimated_close_date
      deposit_due_date
      deposit_received_date
      commission_rate
      contract_close_date
      county
      createdAt
      escrow_due_date
      expired_date
      final_walkthrough_date
      final_water_bill_date
      financing_type
      first_offer_date
      home_inspection_date
      home_inspector
      insurance_agency
      interest_rate
      keys_exchanged_date
      lending_company
      list_date
      listing_contract_signed_date
      listing_expiration_date
      loan_down_payment
      loan_officer
      loan_term
      loan_type
      mortgage_payoff
      mutual_acceptance_date
      mutually_released_date
      net_proceeds
      occupancy_rate
      occupancy_days_allowed
      occupancy_end_date
      occupancy_rate
      offers_received
      opp_id
      opportunitySellingId
      ownerId
      photography_date
      prorated_hoa_dues
      prorated_taxes
      sale_price
      second_mortgage_payoff
      seller_agent_commission
      seller_closing_costs
      showings_received
      staging_date
      title_company
      under_contract_date
      withdrawn_date
      closed_date
      seller_listing_price
      seller_listing_agent_commission_percentage
      seller_buyer_agent_commission_percentage
      seller_broker_fee
      seller_owners_title_insurance
      seller_settlement_costs
      seller_transfer_taxes
      seller_miscellaneous
      seller_prorated_taxes
      seller_prorated_hoa_dues
      seller_mortgage_payoffs
      seller_Net_Proceeds
      financing_first_name_primary
      financing_last_name_primary
      financing_first_name_secondary
      financing_last_name_secondary
      financing_primary_phone
      financing_primary_email
      financing_secondary_phone
      financing_secondary_email
      financing_loan_amount
      financing_loan_term
      financing_interest_rate
      financing_loan_payment
      financing_principal_and_interest
      financing_property_taxes
      financing_insurance
      financing_mortgage_insurance
      financing_type
      financing_appraised_value
      loan_down_payment_currency
      financing_loan_down_payment_percentage
      phase {
        id
        stage
        order
        type
      }
      opportunitySelling {
        id
        createdAt
        opp_id
        list_price_estimate
        subject_square_feet
        timeframe_to_list
        subject_cma_value_low
        subject_cma_value_high
        subject_bedrooms
        subject_bathrooms
        ideal_move_out_date
        phase {
          id
          stage
          type
        }
        createdBy {
          id
          lastName
          firstName
        }
        owner {
          items {
            id
            first_name
            last_name
          }
        }
      }
      realEstateAgent {
        firstName
        lastName
        id
        email
      }
      clientCare {
        firstName
        lastName
        id
        email
      }
      photographer {
        firstName
        lastName
        id
        email
      }
      listingsManager {
        firstName
        lastName
        id
        email
      }
      transactionCoordinator {
        firstName
        lastName
        id
        email
      }
    }
  }
`;

export const transactionLeaseRenter = gql`
  query transactionLeaseRenter($id: ID) {
    transactionLeaseRenter(id: $id) {
      id
      application_fee
      owner {
        id
        first_name
        last_name
        mobile
        email
      }
      address_one
      address_two
      city
      state
      zip
      application_fee_amount
      broker_fee
      closed_date
      createdAt
      homes_seen
      lease_expiration_date
      lease_price
      lease_term
      offers_made
      subject_county
      subject_square_feet
      subject_bedrooms
      subject_bathrooms
      subject_garage
      subject_basement
      subject_waterfront
      lease_term
      lease_signing_date
      lease_start_date
      rent_mo
      rent_annually
      rent_full_contract
      water
      gas
      electricity
      hoa
      application_fee
      security_deposit
      total_listing_commission_percent
      listing_agent_commission_percent
      buyer_agent_commission_percent
      buyer_agent_commission_amount
      total_listing_revenue
      total_revenue
      listing_commission_amount
      appointment_scheduled_date
      appointment_held_date
      broker_agreement_date
      first_tour_date
      first_offer_date
      k_lease_signig_date
      k_lease_start_date
      k_lease_expiration_date
      tours_taken
      opp_id
      phase {
        id
        stage
        order
        type
      }
      opportunityLeaseRenter {
        id
        createdAt
        opp_id
        ideal_payment
        max_payment
        square_feet
        timeframe
        bathrooms
        bedrooms
        ideal_move_in_date
        desired_lease_term
        phase {
          id
          stage
          type
        }
        createdBy {
          id
          lastName
          firstName
        }
        owner {
          items {
            id
            first_name
            last_name
          }
        }
      }
      realEstateAgent {
        firstName
        lastName
        id
        email
      }
      clientCare {
        firstName
        lastName
        id
        email
      }
      photographer {
        firstName
        lastName
        id
        email
      }
      listingsManager {
        firstName
        lastName
        id
        email
      }
      transactionCoordinator {
        firstName
        lastName
        id
        email
      }
    }
  }
`;

export const transactionLeaseListing = gql`
  query transactionLeaseListing($id: ID) {
    transactionLeaseListing(id: $id) {
      id
      actual_closing_date
      owner {
        id
        first_name
        last_name
        mobile
        email
      }
      broker_fee
      property_address_one
      property_address_two
      property_city
      property_state
      property_zip
      buyer_agent_commission
      closing_location
      closing_time
      commission
      commission_rate
      expired_date
      closed_date
      final_water_bill_date
      keys_exchanged_date
      lease_expiration_date
      lease_term
      listing_expiration_date
      move_in_date
      mutual_acceptance_date
      mutually_released_date
      net_proceeds
      occupancy_date
      offers_received
      applications_received
      applications_received_dollar
      total_lease_dollar
      opp_id
      ownerId
      sale_price
      seller_agent_commission
      showings_received
      seller_closing_costs
      subject_address_one
      subject_address_two
      subject_bathrooms
      subject_bedrooms
      subject_city
      subject_cma_value_high
      subject_cma_value_low
      subject_county
      subject_garage
      subject_basement
      subject_square_feet
      subject_state
      subject_waterfront
      subject_zip_code
      timeframe_to_list
      under_contract_date
      lease_signed_date
      lease_end_date
      total_listing_commission
      listing_agent_commission_percentage
      listing_agent_commission_currency
      buyer_agent_commision_percentage
      buyer_agent_commision_currency
      total_listing_revenue
      total_revenue
      leaseinfo_signing_date
      leaseinfo_start_date
      leaseinfo_expiration_date
      rent_mo
      rent_annually
      rent_full_contract
      water
      gas
      electricity
      hoa
      security_deposit_doallar
      appointment_scheduled_date
      appointment_date
      listing_contract_signed_date
      photography_date
      staging_date
      sign_ordered_date
      sign_up_date
      listing_active_date
      first_offer_date
      first_open_house
      second_open_house
      lease_signing_date
      lease_start_date
      renter_first_name_primary
      renter_last_name_primary
      renter_first_name_secondary
      renter_last_name_secondary
      renter_primary_phone
      renter_primary_email
      updatedAt
      withdrawn_date
      phase {
        id
        stage
        order
        type
      }
      opportunityLeaseListing {
        id
        createdAt
        opp_id
        list_price_estimate
        subject_square_feet
        rental_rate_estimate_low
        rental_rate_estimate_high
        subject_bathrooms
        subject_bedrooms
        ideal_move_out_date
        phase {
          id
          stage
          type
        }
        createdBy {
          id
          lastName
          firstName
        }
        owner {
          items {
            id
            first_name
            last_name
          }
        }
      }
      realEstateAgent {
        firstName
        lastName
        id
        email
      }
      clientCare {
        firstName
        lastName
        id
        email
      }
      photographer {
        firstName
        lastName
        id
        email
      }
      listingsManager {
        firstName
        lastName
        id
        email
      }
      transactionCoordinator {
        firstName
        lastName
        id
        email
      }
    }
  }
`;

export const opportunityList = gql`
  query opportunityList {
    opportunityBuyingsList {
      items {
        opp_id
        id
        phase {
          id
          stage
          order
        }
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        owner {
          items {
            id
            first_name
            last_name
          }
        }
      }
    }
    opportunitySellingsList {
      items {
        id
        opp_id
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        phase {
          id
          stage
          order
        }
        owner {
          items {
            id
            first_name
            last_name
          }
        }
      }
    }
    opportunityLeaseRentersList {
      items {
        id
        opp_id
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        phase {
          id
          stage
          order
        }
        owner {
          items {
            id
            first_name
            last_name
          }
        }
      }
    }
    opportunityLeaseListingsList {
      items {
        id
        opp_id
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        phase {
          id
          stage
          order
        }
        owner {
          items {
            id
            first_name
            last_name
          }
        }
      }
    }
  }
`;

export const transactionList = gql`
  query transactionList {
    transactionBuyingsList {
      items {
        id
        opp_id
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        phase {
          id
          stage
          order
        }
        owner {
          id
          first_name
          last_name
        }
      }
    }
    transactionSellingsList {
      items {
        id
        opp_id
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        phase {
          id
          stage
          order
        }
        owner {
          id
          first_name
          last_name
        }
      }
    }
    transactionLeaseListingsList {
      items {
        id
        opp_id
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        phase {
          id
          stage
          order
        }
        owner {
          id
          first_name
          last_name
        }
      }
    }
    transactionLeaseRentersList {
      items {
        id
        opp_id
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        phase {
          id
          stage
          order
        }
        owner {
          id
          first_name
          last_name
        }
      }
    }
  }
`;

export const opportunityBuying = gql`
  query opportunityBuying($id: ID) {
    opportunityBuying(id: $id) {
      id
      tours
      phase {
        id
        stage
        order
        allowedStages
        __typename
      }
      square_feet
      offers_made
      max_payment
      loan_officer
      ideal_move_in_date
      cities_searching
      square_feet
      bedrooms
      bathrooms
      waterfront
      appointment_scheduled_date
      appointment_date
      ideal_payment
      homes_seen
      first_showing_date
      first_offer_date
      financing_type
      down_payment_amount
      broker_agreement_date
      garage
      basement
      notes
      loan_officer_company
      loan_officer_phone
      loan_officer_email
      down_payment_percentage
      pre_approval_status
      ideal_purchase_price
      max_purchase_price
      opp_id
      __typename
      realEstateAgent {
        firstName
        lastName
        id
        email
      }
      clientCare {
        firstName
        lastName
        id
        email
      }
      photographer {
        firstName
        lastName
        id
        email
      }
      listingsManager {
        firstName
        lastName
        id
        email
      }
      transactionCoordinator {
        firstName
        lastName
        id
        email
      }
    }
  }
`;

export const opportunitySelling = gql`
  query opportunitySelling($id: ID) {
    opportunitySelling(id: $id) {
      id
      subject_address_one
      subject_address_two
      realEstateAgent {
        firstName
        lastName
        id
        email
      }
      clientCare {
        firstName
        lastName
        id
        email
      }
      photographer {
        firstName
        lastName
        id
        email
      }
      listingsManager {
        firstName
        lastName
        id
        email
      }
      transactionCoordinator {
        firstName
        lastName
        id
        email
      }
      owner {
        items {
          id
          first_name
          last_name
          email
          mobile
          preferred_contact_method
        }
      }
      phase {
        id
        stage
        order
      }
      appointment_date
      appointment_scheduled
      list_price_estimate
      locl_box_code
      subject_cma_value_low
      subject_cma_value_high
      subject_square_feet
      subject_bedrooms
      subject_bathrooms
      subject_garage
      subject_basement
      subject_waterfront
      subject_county
      broker_fee
      opp_id
      buyer_agent_commission
      commission
      commission_rate
      county
      createdAt
      ending_list_price
      expired_date
      first_offer_date
      ideal_move_out_date
      list_date
      listing_contract_signed_date
      listing_expiration_date
      mortgage_payoff
      net_proceeds
      offers_received
      open_house_date
      opportunity_id
      original_list_price
      photography_date
      prorated_hoa_dues
      prorated_taxes
      second_mortgage_payoff
      seller_agent_commission
      seller_closing_costs
      showings_received
      staging_date

      subject_city
      subject_zip_code
      subject_state
      timeframe_to_list
      title_company
      total_listing_commission_percantage
      total_listing_agent_commission_percantage
      listing_agent_commission_dollar
      buyer_agent_commision_percentage
      buyer_agent_commission_dollar
      total_listing_revenue
      total_revenue

      listing_price
      seller_listing_agent_commission_dollar
      seller_buyer_agent_commission_dollar
      owners_title_insurance
      settlement_costs
      transfer_taxes
      miscellaneous
      seller_broker_fee

      sign_ordered_date
      sign_up_date
      open_house_date
    }
  }
`;

export const opportunityLeaseRenter = gql`
  query opportunityLeaseRenter($id: ID) {
    opportunityLeaseRenter(id: $id) {
      id
      owner {
        items {
          id
          first_name
          last_name
          email
          mobile
          preferred_contact_method
        }
      }
      phase {
        id
        stage
        order
      }
      opp_id
      bathrooms
      basement
      bedrooms
      broker_agreement_date
      cities_searching
      first_offer_date
      first_showing_date
      garage
      ideal_move_in_date
      ideal_payment
      ideal_lease_length
      desired_lease_term
      appointment_scheduled_date
      appointment_date
      monthly_income
      max_lease_length
      notes
      credit_score
      max_payment
      square_feet
      timeframe
      updatedAt
      waterfront
      realEstateAgent {
        firstName
        lastName
        id
        email
      }
      clientCare {
        firstName
        lastName
        id
        email
      }
      photographer {
        firstName
        lastName
        id
        email
      }
      listingsManager {
        firstName
        lastName
        id
        email
      }
      transactionCoordinator {
        firstName
        lastName
        id
        email
      }
    }
  }
`;

export const opportunityLeaseListing = gql`
  query opportunityLeaseListing($id: ID) {
    opportunityLeaseListing(id: $id) {
      id
      property_address_one
      property_address_two
      property_city
      property_state
      property_zip
      address_one
      address_two
      ending_list_price
      first_offer_date
      ideal_move_out_date
      list_date
      listing_contract_signed_date
      listing_expiration_date
      open_house_date
      original_list_price
      rental_rate_estimate_high
      rental_rate_estimate_low
      list_price_estimate
      appointment_scheduled
      appointment_date
      application_fee
      application_fee_currency
      lock_box_code
      showings_received
      offers_received
      total_listing_commission
      listing_agent_commission_percentage
      listing_agent_commission_currency
      broker_fee
      buyer_agent_commision_percentage
      buyer_agent_commision_currency
      total_listing_revenue
      total_revenue
      sign_ordered_date
      sign_up_date
      listing_active_date
      first_open_house
      second_open_house
      opp_id
      phase {
        id
        stage
        order
      }
      owner {
        items {
          id
          first_name
          last_name
          email
          mobile
          preferred_contact_method
        }
      }
      photography_date
      staging_date
      subject_bathrooms
      subject_bedrooms
      subject_city
      subject_cma_value_high
      subject_cma_value_low
      subject_county
      address_one
      address_two
      subject_square_feet
      subject_waterfront
      subject_state
      subject_zip_code
      subject_basement
      subject_garage
      realEstateAgent {
        firstName
        lastName
        id
        email
      }
      clientCare {
        firstName
        lastName
        id
        email
      }
      photographer {
        firstName
        lastName
        id
        email
      }
      listingsManager {
        firstName
        lastName
        id
        email
      }
      transactionCoordinator {
        firstName
        lastName
        id
        email
      }
    }
  }
`;

export const opportunityBuyingUpdate = gql`
  mutation opportunityBuyingUpdate($data: OpportunityBuyingUpdateInput!) {
    opportunityBuyingUpdate(data: $data) {
      id
    }
  }
`;

export const opportunitySellingUpdate = gql`
  mutation opportunitySellingUpdate($data: OpportunitySellingUpdateInput!) {
    opportunitySellingUpdate(data: $data) {
      id
    }
  }
`;

export const opportunityLeaseRenterUpdate = gql`
  mutation opportunityLeaseRenterUpdate(
    $data: OpportunityLeaseRenterUpdateInput!
  ) {
    opportunityLeaseRenterUpdate(data: $data) {
      id
    }
  }
`;

export const opportunityLeaseListingUpdate = gql`
  mutation opportunityLeaseListingUpdate(
    $data: OpportunityLeaseListingUpdateInput!
  ) {
    opportunityLeaseListingUpdate(data: $data) {
      id
    }
  }
`;

export const leadInfoBuying = gql`
  query leadInfoBuying($id: ID) {
    leadInfoBuying(id: $id) {
      id
      appointment_date
      appointment_scheduled_date
      bathrooms
      bedrooms
      cities_searching
      createdAt
      down_payment_amount
      financing_type

      ideal_move_in_date
      ideal_payment
      lending_company
      loan_officer

      max_payment
      pre_approval_status
      square_feet
      waterfront
      garage
      basement
      notes
      loan_officer_phone
      loan_officer_email
      down_payment_percentage
      ideal_purchase_price
      max_purchase_price
      broker_agreement_date
      first_tour_date
      first_offer_date
    }
  }
`;
export const leadInfoSelling = gql`
  query leadInfoSelling($id: ID) {
    leadInfoSelling(id: $id) {
      id
      appointment_date
      appointment_scheduled
      createdAt
      ideal_move_out_date
      list_price_estimate

      subject_bedrooms
      subject_bathrooms
      subject_city
      subject_cma_value_high
      subject_cma_value_low
      subject_county
      subject_square_feet
      subject_state
      subject_zip_code
      subject_garage
      subject_waterfront
      subject_basement
    }
  }
`;
export const leadInfoLeaseRenter = gql`
  query leadInfoLeaseRenter($id: ID) {
    leadInfoLeaseRenter(id: $id) {
      id
      appointment_date
      appointment_scheduled_date
      bathrooms
      bedrooms
      cities_searching
      createdAt
      credit_score
      deletedAt
      desired_lease_term
      r_garage
      r_basement
      r_notes
      ideal_move_in_date
      ideal_payment
      ideal_lease_length
      max_lease_length
      max_payment
      monthly_income
      square_feet
      timeframe
      waterfront
    }
  }
`;
export const leadInfoLeaseListing = gql`
  query leadInfoLeaseListing($id: ID) {
    leadInfoLeaseListing(id: $id) {
      id
      appointment_date
      appointment_scheduled
      createdAt
      ideal_move_out_date
      list_price_estimate
      rental_rate_estimate_high
      rental_rate_estimate_low

      subject_bathrooms
      subject_bedrooms
      subject_city
      subject_cma_value_high
      subject_cma_value_low
      subject_county
      subject_garage
      subject_basement
      subject_square_feet
      subject_state
      subject_waterfront
      subject_zip_code
      property_zip
    }
  }
`;

export const leadInfoUpdate = gql`
  mutation leadInfoUpdate(
    $buying: LeadInfoBuyingUpdateInput!
    $selling: LeadInfoSellingUpdateInput!
    $leaseRenter: LeadInfoLeaseRenterUpdateInput!
    $leaseListing: LeadInfoLeaseListingUpdateInput!
  ) {
    leadInfoBuyingUpdate(data: $buying) {
      id
    }
    leadInfoSellingUpdate(data: $selling) {
      id
    }
    leadInfoLeaseRenterUpdate(data: $leaseRenter) {
      id
    }
    leadInfoLeaseListingUpdate(data: $leaseListing) {
      id
    }
  }
`;

export const leadInfoCreate = gql`
  mutation leadInfoCreate(
    $buying: LeadInfoBuyingCreateInput!
    $sellingData: LeadInfoSellingCreateInput!
    $leaseRenter: LeadInfoLeaseRenterCreateInput!
    $leaseListing: LeadInfoLeaseListingCreateInput!
  ) {
    leadInfoBuyingCreate(data: $buying) {
      id
    }
    leadInfoSellingCreate(data: $sellingData) {
      id
    }
    leadInfoLeaseRenterCreate(data: $leaseRenter) {
      id
    }
    leadInfoLeaseListingCreate(data: $leaseListing) {
      id
    }
  }
`;

export const transationBuyingCreate = gql`
  mutation transactionBuyingCreate($data: TransactionBuyingCreateInput!) {
    transactionBuyingCreate(data: $data) {
      id
    }
  }
`;

export const transactionSellingCreate = gql`
  mutation transactionSellingCreate($data: TransactionSellingCreateInput!) {
    transactionSellingCreate(data: $data) {
      id
    }
  }
`;

export const transactionLeaseRenterCreate = gql`
  mutation transactionLeaseRenterCreate(
    $data: TransactionLeaseRenterCreateInput!
  ) {
    transactionLeaseRenterCreate(data: $data) {
      id
    }
  }
`;

export const transactionLeaseListingCreate = gql`
  mutation transactionLeaseListingCreate(
    $data: TransactionLeaseListingCreateInput!
  ) {
    transactionLeaseListingCreate(data: $data) {
      id
    }
  }
`;

export const transationBuyingsList = gql`
  query transactionBuyingsList($filter: TransactionBuyingFilter) {
    transactionBuyingsList(filter: $filter) {
      items {
        id
        createdAt
        appraisal_date
        broker_fee
        central_air_age
        central_air_model
        close_date
        closed_date
        commission
        commission_rate
        concessions
        deposit
        dishwasher_age
        dishwasher_model
        dryer_age
        dryer_model

        escrow_signing_date_time
        estimated_closed_date

        final_walkthtrough_date
        financing_or_cash
        financing_type
        furnace_age
        furnace_filter_size
        furnace_model
        home_inspection_date
        hot_water_age
        hot_water_model

        interest_rate
        keys_exchanged_date

        loan_down_payment

        loan_term

        mutual_release_date
        occupancy_date
        occupancy_days_allowed
        occupancy_end_date

        purchase_price
        range_age
        range_model
        refridgerator_age
        refridgerator_model
        roof_age
        roof_type
        septic_tank_age
        staging_agent
        sump_pump_age
        sump_pump_back_up
        sump_pump_model

        under_contract_date
        inspection_status
        appraisal_status
        loan_status

        washer_age
        washer_model
        water_softener_age
        water_softener_model
        opp_id
        phase {
          id
          stage
          order
        }
        opportunityBuying {
          id

          square_feet
          financing_type
          bathrooms
          bedrooms
          ideal_move_in_date
          down_payment_amount
        }
      }
    }
  }
`;

export const transactionSellingsList = gql`
  query transactionSellingsList($filter: TransactionSellingFilter) {
    transactionSellingsList(filter: $filter) {
      items {
        id
        actual_closing_date
        appraisal_date
        broker_fee
        buyer_agent_commission
        closing_location
        closing_time
        commission
        commission_rate
        concessions
        contract_close_date
        county
        createdAt
        escrow_due_date
        expired_date
        final_walkthrough_date
        final_water_bill_date
        financing_type
        first_offer_date
        home_inspection_date
        home_inspector
        insurance_agency
        interest_rate
        keys_exchanged_date
        lending_company
        list_date
        listing_contract_signed_date
        listing_expiration_date
        loan_down_payment
        loan_officer
        loan_term
        loan_type
        mortgage_payoff
        mutual_acceptance_date
        mutually_released_date
        net_proceeds
        occupancy_rate
        occupancy_days_allowed
        occupancy_end_date
        occupancy_rate
        offers_received
        photography_date
        prorated_hoa_dues
        prorated_taxes
        sale_price
        second_mortgage_payoff
        seller_agent_commission
        seller_closing_costs
        showings_received
        staging_date
        title_company
        under_contract_date
        under_contract_date
        inspection_status
        appraisal_status
        loan_status
        contract_close_date

        withdrawn_date
        opp_id
        phase {
          id
          stage
          order
        }
        opportunitySelling {
          id
          list_price_estimate
          subject_square_feet
          timeframe_to_list
          subject_cma_value_low
          subject_cma_value_high
          subject_bedrooms
          subject_bathrooms
          ideal_move_out_date
        }
      }
    }
  }
`;

export const transactionLeaseRentersList = gql`
  query transactionLeaseRentersList($filter: TransactionLeaseRenterFilter) {
    transactionLeaseRentersList(filter: $filter) {
      items {
        application_fee
        application_fee_amount
        broker_fee
        closed_date
        createdAt
        deposit
        homes_seen
        id
        lease_expiration_date
        lease_price
        lease_term
        lease_signing_date
        offers_made
        security_deposit
        tours_taken
        rent_mo
        security_deposit
        lease_signing_date
        lease_start_date
        opp_id
        phase {
          id
          stage
          order
        }
        opportunityLeaseRenter {
          id
          ideal_payment
          max_payment
          square_feet
          timeframe
          bathrooms
          bedrooms
          ideal_move_in_date
          desired_lease_term
        }
      }
    }
  }
`;

export const transactionLeaseListingsList = gql`
  query transactionLeaseListingsList($filter: TransactionLeaseListingFilter) {
    transactionLeaseListingsList(filter: $filter) {
      items {
        id
        actual_closing_date
        broker_fee
        buyer_agent_commission
        closing_location
        closing_time
        commission
        commission_rate
        createdAt
        expired_date
        final_water_bill_date
        keys_exchanged_date
        lease_expiration_date
        listing_expiration_date
        lease_term
        move_in_date
        mutual_acceptance_date
        mutually_released_date
        net_proceeds
        occupancy_date
        offers_received
        sale_price
        seller_agent_commission
        showings_received
        seller_closing_costs
        subject_bathrooms
        subject_bedrooms
        subject_city
        subject_cma_value_high
        subject_cma_value_low
        subject_county

        subject_square_feet
        subject_state
        subject_waterfront
        subject_zip_code
        timeframe_to_list
        under_contract_date
        withdrawn_date

        rent_mo
        security_deposit_doallar
        lease_signed_date
        lease_start_date

        opp_id
        phase {
          id
          stage
          order
        }
        opportunityLeaseListing {
          id
          list_price_estimate
          subject_square_feet
          rental_rate_estimate_low
          rental_rate_estimate_high
          subject_bathrooms
          subject_bedrooms
          ideal_move_out_date
        }
      }
    }
  }
`;

export const opportunityBuyingDelete = gql`
  mutation opportunityBuyingDelete($data: OpportunityBuyingDeleteInput) {
    opportunityBuyingDelete(data: $data) {
      success
    }
  }
`;

export const opportunitySellingDelete = gql`
  mutation opportunitySellingDelete($data: OpportunitySellingDeleteInput) {
    opportunitySellingDelete(data: $data) {
      success
    }
  }
`;

export const opportunityLeaseRenterDelete = gql`
  mutation opportunityLeaseRenterDelete(
    $data: OpportunityLeaseRenterDeleteInput
  ) {
    opportunityLeaseRenterDelete(data: $data) {
      success
    }
  }
`;

export const opportunityLeaseListingDelete = gql`
  mutation opportunityLeaseListingDelete(
    $data: OpportunityLeaseListingDeleteInput
  ) {
    opportunityLeaseListingDelete(data: $data) {
      success
    }
  }
`;

export const transactionBuyingDelete = gql`
  mutation transactionBuyingDelete($data: TransactionBuyingDeleteInput) {
    transactionBuyingDelete(data: $data) {
      success
    }
  }
`;

export const transactionSellingDelete = gql`
  mutation transactionSellingDelete($data: TransactionSellingDeleteInput) {
    transactionSellingDelete(data: $data) {
      success
    }
  }
`;

export const transactionLeaseRenterDelete = gql`
  mutation transactionLeaseRenterDelete(
    $data: TransactionLeaseRenterDeleteInput
  ) {
    transactionLeaseRenterDelete(data: $data) {
      success
    }
  }
`;

export const transactionLeaseListingDelete = gql`
  mutation transactionLeaseListingDelete(
    $data: TransactionLeaseListingDeleteInput
  ) {
    transactionLeaseListingDelete(data: $data) {
      success
    }
  }
`;

export const taskTemplatesList = gql`
  query taskTemplatesList {
    taskTemplatesList {
      items {
        id
        name
      }
    }
  }
`;

export const taskTemplate = gql`
  query taskTemplate($id: ID!) {
    taskTemplate(id: $id) {
      id
      name
    }
  }
`;

export const taskTemplateUpdate = gql`
  mutation taskTemplateUpdate($data: TaskTemplateUpdateInput!) {
    taskTemplateUpdate(data: $data) {
      id
    }
  }
`;

export const taskTemplateCreate = gql`
  mutation taskTemplateCreate($data: TaskTemplateCreateInput!) {
    taskTemplateCreate(data: $data) {
      id
      name
    }
  }
`;

export const rolesList = gql`
  query usersList {
    rolesList {
      items {
        id
        name
      }
    }
  }
`;

export const taskTemplateDelete = gql`
  mutation taskTemplateDelete($data: TaskTemplateDeleteInput) {
    taskTemplateDelete(data: $data) {
      success
    }
  }
`;

export const phaseUpdate = gql`
  mutation phaseUpdate($data: PhaseUpdateInput!) {
    phaseUpdate(data: $data) {
      id
      type
    }
  }
`;

export const templateTasksList = gql`
  query templateTasksList($filter: TemplateTaskFilter) {
    templateTasksList(filter: $filter) {
      items {
        id
        name
        days
        assignment
        doc_type {
          id
          doc_name
        }
        users {
          id
          email
          lastName
          firstName
        }
        internalUserRole {
          id
          name
          contact_type
        }
        type
        phase {
          id
          stage
          type
        }
        tenants {
          id
        }
      }
    }
  }
`;

export const templateTaskDestroy = gql`
  mutation templateTaskDestroy($filter: TemplateTaskKeyFilter) {
    templateTaskDestroy(filter: $filter) {
      success
    }
  }
`;

export const templateTaskCreate = gql`
  mutation templateTaskCreate($data: TemplateTaskCreateInput!) {
    templateTaskCreate(data: $data) {
      id
    }
  }
`;

export const templateTaskUpdate = gql`
  mutation templateTaskUpdate($data: TemplateTaskUpdateInput!) {
    templateTaskUpdate(data: $data) {
      id
    }
  }
`;

export const createTask = gql`
  mutation createTask(
    $phaseId: String!
    $typeOfItem: String!
    $typeId: String!
    $contactId: String
  ) {
    createTask(
      phaseId: $phaseId
      typeOfItem: $typeOfItem
      contactId: $contactId
      typeId: $typeId
    ) {
      result
    }
  }
`;

export const internalUserRolesList = gql`
  query internalUserRolesList($filter:InternalUserRoleFilter) {
    internalUserRolesList(filter:$filter) {
      items {
        id
        name
        contact_type
        user_type
      }
    }
  }
`;

export const documentTypesList = gql`
  query documentTypesList {
    documentTypesList {
      items {
        id
        doc_name
        doc_id
      }
    }
  }
`;

export const CREDIT_REPORT_QUERY = gql`
  query creditReport($id: ID) {
    creditReport(id: $id) {
      createdAt
      base64Data
    }
  }
`;

export const CREDIT_REPORT_MUTATION = gql`
  mutation getCreditReport(
    $FirstName: String!
    $LastName: String!
    $MiddleName: String
    $SuffixName: String
    $AddressLineText: String!
    $CityName: String!
    $PostalCode: String!
    $StateCode: String!
    $TaxpayerIdentifierValue: String!
    $userId: String!
    $contactsId: String
  ) {
    getCreditReport(
      FirstName: $FirstName
      LastName: $LastName
      MiddleName: $MiddleName
      SuffixName: $SuffixName
      AddressLineText: $AddressLineText
      CityName: $CityName
      PostalCode: $PostalCode
      StateCode: $StateCode
      TaxpayerIdentifierValue: $TaxpayerIdentifierValue
      userId: $userId
      contactsId: $contactsId
    ) {
      result
      xmlResult
    }
  }
`;

export const CREDIT_REPORT_LIST = gql`
  query creditReportsList($contactsId: ID!) {
    creditReportsList(
      filter: { contacts: { id: { equals: $contactsId } } }
      orderBy: createdAt_DESC
    ) {
      items {
        id
        createdAt
      }
    }
  }
`;

export const opportunityContactCreate = gql`
  mutation opportunityContactCreate($data: OpportunityContactCreateInput!) {
    opportunityContactCreate(data: $data) {
      id
    }
  }
`;

export const opportunityContactsList = gql`
  query opportunityContactsList($filter: OpportunityContactFilter) {
    opportunityContactsList(filter: $filter) {
      items {
        id
        is_primary
        contacts {
          tenantsId
          id
          last_name
          first_name
          email
          mobile
          real_estate_agent {
            id
            status
            email
            origin
            firstName
            lastName
            __typename
          }
          transaction_coordinator {
            id
            status
            email
            origin
            firstName
            lastName
            __typename
          }

          client_care {
            id
            status
            email
            origin
            firstName
            lastName
            __typename
          }
          listings_manager {
            id
            status
            email
            origin
            firstName
            lastName
            __typename
          }
          photographer {
            id
            status
            email
            origin
            firstName
            lastName
            __typename
          }
        }
        opportunityBuying {
          id
          createdAt
          bedrooms
          bathrooms

          cities_searching
          ideal_move_in_date
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          transationBuyings {
            items {
              id
              home_inspection_date
              appraisal_date
              commission
              close_date
              closed_date
              broker_fee
              occupancy_date
              createdBy {
                id
                firstName
                lastName
              }
              phase {
                id
                stage
                order
                status
              }
              purchase_price
              concessions
              deposit
              opp_id
              financing_or_cash
              phaseId
              opp_id
              createdAt
            }
          }
          financing_type

          loan_officer
          down_payment_amount
          ideal_payment
          max_payment

          tours
          homes_seen
          offers_made
          broker_agreement_date
          first_showing_date
          first_offer_date
          square_feet
          opp_id
        }
        opportunitySelling {
          id
          createdAt
          subject_square_feet
          timeframe_to_list
          subject_cma_value_low
          subject_cma_value_high
          subject_bedrooms
          subject_bathrooms
          ideal_move_out_date
          list_price_estimate

          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          transactionSellings {
            items {
              id
              title_company
              createdAt
              commission
              broker_fee
              commission
              home_inspection_date
              sale_price
              contract_close_date
              occupancy_days_allowed
              seller_agent_commission
              occupancy_end_date
              broker_fee
              appraisal_date
              opp_id
              createdBy {
                id
                firstName
                lastName
              }
              phase {
                id
                stage
                order
                status
              }
            }
          }
          ideal_move_out_date
          expired_date
          first_offer_date
          staging_date
          photography_date
          listing_contract_signed_date
          net_proceeds
          prorated_hoa_dues
          prorated_taxes

          subject_city
          subject_state
          subject_zip_code
          opportunity_id
          original_list_price
          list_date
          open_house_date
          ending_list_price
          listing_expiration_date
          timeframe_to_list
          title_company
          broker_fee
          commission_rate
          showings_received
          offers_received
          county
          buyer_agent_commission
          seller_agent_commission
          seller_closing_costs
          mortgage_payoff
          second_mortgage_payoff
          opp_id
        }
        opportunityLeaseRenter {
          id
          desired_lease_term
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          transactionLeaseRenters {
            items {
              id
              closed_date
              createdAt
              opp_id
              createdBy {
                id
                firstName
                lastName
              }
              phase {
                id
                stage
                order
                status
              }

              close_date
              commission
              security_deposit
              broker_fee

              lease_term
              deposit
            }
          }
          timeframe
          cities_searching
          ideal_move_in_date
          ideal_payment
          max_payment
          square_feet
          bedrooms
          bathrooms
          waterfront
          broker_agreement_date
          first_showing_date
          first_offer_date
          opp_id
        }
        opportunityLeaseListing {
          id
          createdAt
          list_price_estimate
          subject_square_feet
          subject_bedrooms
          subject_bathrooms
          rental_rate_estimate_low
          rental_rate_estimate_high
          createdBy {
            id
            firstName
            lastName
          }
          phase {
            id
            stage
            order
            status
          }
          transactionLeaseListings {
            items {
              createdBy {
                id
                firstName
                lastName
              }
              phase {
                id
                stage
                order
                status
              }
              id
              sale_price
              listing_expiration_date
              move_in_date
              seller_agent_commission
              broker_fee
              phaseId
              ownerId
              opp_id
              createdAt
              subject_city
            }
          }
          original_list_price
          list_date
          open_house_date
          listing_contract_signed_date
          photography_date
          staging_date
          listing_expiration_date
          first_offer_date
          ending_list_price
          ideal_move_out_date
          subject_city
          subject_state
          subject_zip_code
          subject_square_feet
          subject_bedrooms
          subject_bathrooms
          subject_waterfront
          subject_county
          subject_cma_value_low
          subject_cma_value_high
          opp_id
        }
      }
    }
  }
`;

export const opportunityContactUpdate = gql`
  mutation opportunityContactUpdate($data: OpportunityContactUpdateInput!) {
    opportunityContactUpdate(data: $data) {
      id
    }
  }
`;

export const opportunityContactDestroy = gql`
  mutation opportunityContactDestroy($filter: OpportunityContactKeyFilter!) {
    opportunityContactDestroy(filter: $filter) {
      success
    }
  }
`;

export const tenantsList = gql`
  query tenantsList {
    tenantsList {
      items {
        id
        company_name
        access_token_data
        users {
          items {
            id
            email
            status
            origin
          }
        }
        uUID
      }
    }
  }
`;

export const systemIntegrationsList = gql`
  query systemIntegrationsList {
    systemIntegrationsList {
      items {
        id
        name
        post_url_base
        _description
      }
    }
  }
`;

export const tenantUpdate = gql`
  mutation tenantUpdate($data: TenantUpdateInput!) {
    tenantUpdate(data: $data) {
      id
    }
  }
`;

export const userPortal = gql`
  query userPortal($id: ID) {
    user(id: $id) {
      portal_user_account {
        id
        transactionSellings {
          items {
            id
            title_company
            createdAt
            commission
            broker_fee
            commission
            home_inspection_date
            closed_date
            sale_price
            contract_close_date
            occupancy_days_allowed
            seller_agent_commission
            occupancy_end_date
            broker_fee
            appraisal_date
            opp_id
            createdBy {
              id
              firstName
              lastName
            }
            phase {
              id
              stage
              order
            }
          }
        }
        transactionLeaseListings {
          items {
            createdBy {
              id
              firstName
              lastName
            }
            phase {
              id
              stage
              order
            }
            id
            sale_price
            listing_expiration_date
            move_in_date
            seller_agent_commission
            broker_fee
            phaseId
            ownerId
            opp_id
            createdAt
            subject_city
            closed_date
          }
        }
        transactionLeaseRenters {
          items {
            id

            closed_date
            createdAt
            opp_id
            createdBy {
              id
              firstName
              lastName
            }
            phase {
              id
              stage
              order
            }

            close_date
            commission
            security_deposit
            broker_fee

            lease_term
            deposit
          }
        }
        transationBuying {
          items {
            id
            home_inspection_date
            appraisal_date
            commission
            close_date
            closed_date
            broker_fee
            occupancy_date
            createdBy {
              id
              firstName
              lastName
            }
            phase {
              id
              stage
              order
            }
            purchase_price
            concessions
            deposit
            opp_id
            financing_or_cash
            phaseId
            opp_id
            createdAt
          }
        }
      }
    }
  }
`;

export const portalUserTasks = gql`
  query portalUserTasks($email: String) {
    user(email: $email) {
      email
      firstName
      lastName
      id
      portal_user_account {
        email
        first_name
        last_name
        id
        tasks(filter: { assignment_type: { contains: "contact" } }) {
          items {
            id
            task_name
            status
            assignment_type
            type
            due_date
            doc_type {
              id
              doc_name
            }
            attachments {
              id
              fileId
              filename
              downloadUrl
              shareUrl
            }
            contacts {
              email
              first_name
              last_name
              id
              mobile
            }
            internalUserRole {
              id
              name
            }
            users {
              id
              email
              lastName
              firstName
            }
            opportunityBuying {
              id
              opp_id
            }
            opportunitySelling {
              id
              opp_id
            }
            opportunityLeaseRenter {
              id
              opp_id
            }
            opportunityLeaseListing {
              id
              opp_id
            }
            transactionBuying {
              id
              opp_id
            }
            transactionSelling {
              id
              opp_id
            }
            transactionLeaseRenter {
              id
              opp_id
            }
            transactionLeaseListing {
              id
              opp_id
            }
          }
        }
        opportunityBuyings {
          items {
            tasks(filter: { assignment_type: { contains: "contact" } }) {
              items {
                id
                task_name
                status
                assignment_type
                type
                due_date
                doc_type {
                  id
                  doc_name
                }
                attachments {
                  id
                  fileId
                  filename
                  downloadUrl
                  shareUrl
                }
                contacts {
                  id
                  email
                  first_name
                  last_name
                  mobile
                }
                internalUserRole {
                  id
                  name
                }
                users {
                  id
                  email
                  lastName
                  firstName
                }
                opportunityBuying {
                  opp_id
                  id
                }
                opportunityBuying {
                  id
                  opp_id
                }
                opportunitySelling {
                  id
                  opp_id
                }
                opportunityLeaseRenter {
                  id
                  opp_id
                }
                opportunityLeaseListing {
                  id
                  opp_id
                }
                transactionBuying {
                  id
                  opp_id
                }
                transactionSelling {
                  id
                  opp_id
                }
                transactionLeaseRenter {
                  id
                  opp_id
                }
                transactionLeaseListing {
                  id
                  opp_id
                }
              }
            }
          }
        }
        opportunitySellings {
          items {
            tasks(filter: { assignment_type: { contains: "contact" } }) {
              items {
                id
                task_name
                status
                assignment_type
                type
                due_date
                doc_type {
                  id
                  doc_name
                }
                attachments {
                  id
                  fileId
                  filename
                  downloadUrl
                  shareUrl
                }
                contacts {
                  email
                  first_name
                  last_name
                  id
                  mobile
                }
                internalUserRole {
                  id
                  name
                }
                users {
                  id
                  email
                  lastName
                  firstName
                }
                opportunityBuying {
                  id
                  opp_id
                }
                opportunitySelling {
                  id
                  opp_id
                }
                opportunityLeaseRenter {
                  id
                  opp_id
                }
                opportunityLeaseListing {
                  id
                  opp_id
                }
                transactionBuying {
                  id
                  opp_id
                }
                transactionSelling {
                  id
                  opp_id
                }
                transactionLeaseRenter {
                  id
                  opp_id
                }
                transactionLeaseListing {
                  id
                  opp_id
                }
              }
            }
          }
        }
        opportunityLeaseRenters {
          items {
            tasks(filter: { assignment_type: { contains: "contact" } }) {
              items {
                id
                task_name
                status
                assignment_type
                type
                due_date
                doc_type {
                  id
                  doc_name
                }
                attachments {
                  id
                  fileId
                  filename
                  downloadUrl
                  shareUrl
                }
                contacts {
                  email
                  first_name
                  last_name
                  id
                  mobile
                }
                internalUserRole {
                  id
                  name
                }
                users {
                  id
                  email
                  lastName
                  firstName
                }
                opportunityBuying {
                  id
                  opp_id
                }
                opportunitySelling {
                  id
                  opp_id
                }
                opportunityLeaseRenter {
                  id
                  opp_id
                }
                opportunityLeaseListing {
                  id
                  opp_id
                }
                transactionBuying {
                  id
                  opp_id
                }
                transactionSelling {
                  id
                  opp_id
                }
                transactionLeaseRenter {
                  id
                  opp_id
                }
                transactionLeaseListing {
                  id
                  opp_id
                }
              }
            }
          }
        }
        opportunityLeaseListings {
          items {
            tasks(filter: { assignment_type: { contains: "contact" } }) {
              items {
                id
                task_name
                status
                assignment_type
                type
                due_date
                doc_type {
                  id
                  doc_name
                }
                attachments {
                  id
                  fileId
                  filename
                  downloadUrl
                  shareUrl
                }
                contacts {
                  email
                  first_name
                  last_name
                  id
                  mobile
                }
                internalUserRole {
                  id
                  name
                }
                users {
                  id
                  email
                  lastName
                  firstName
                }
                opportunityBuying {
                  id
                  opp_id
                }
                opportunitySelling {
                  id
                  opp_id
                }
                opportunityLeaseRenter {
                  id
                  opp_id
                }
                opportunityLeaseListing {
                  id
                  opp_id
                }
                transactionBuying {
                  id
                  opp_id
                }
                transactionSelling {
                  id
                  opp_id
                }
                transactionLeaseRenter {
                  id
                  opp_id
                }
                transactionLeaseListing {
                  id
                  opp_id
                }
              }
            }
          }
        }
        transationBuying {
          items {
            tasks(filter: { assignment_type: { contains: "contact" } }) {
              items {
                id
                task_name
                status
                assignment_type
                type
                due_date
                doc_type {
                  id
                  doc_name
                }
                attachments {
                  id
                  fileId
                  filename
                  downloadUrl
                  shareUrl
                }
                contacts {
                  email
                  first_name
                  last_name
                  id
                  mobile
                }
                internalUserRole {
                  id
                  name
                }
                users {
                  id
                  email
                  lastName
                  firstName
                }
                opportunityBuying {
                  id
                  opp_id
                }
                opportunitySelling {
                  id
                  opp_id
                }
                opportunityLeaseRenter {
                  id
                  opp_id
                }
                opportunityLeaseListing {
                  id
                  opp_id
                }
                transactionBuying {
                  id
                  opp_id
                }
                transactionSelling {
                  id
                  opp_id
                }
                transactionLeaseRenter {
                  id
                  opp_id
                }
                transactionLeaseListing {
                  id
                  opp_id
                }
              }
            }
          }
        }
        transactionSellings {
          items {
            tasks(filter: { assignment_type: { contains: "contact" } }) {
              items {
                id
                task_name
                status
                assignment_type
                type
                due_date
                doc_type {
                  id
                  doc_name
                }
                attachments {
                  id
                  fileId
                  filename
                  downloadUrl
                  shareUrl
                }
                contacts {
                  email
                  first_name
                  last_name
                  id
                  mobile
                }
                internalUserRole {
                  id
                  name
                }
                users {
                  id
                  email
                  lastName
                  firstName
                }
                opportunityBuying {
                  id
                  opp_id
                }
                opportunitySelling {
                  id
                  opp_id
                }
                opportunityLeaseRenter {
                  id
                  opp_id
                }
                opportunityLeaseListing {
                  id
                  opp_id
                }
                transactionBuying {
                  id
                  opp_id
                }
                transactionSelling {
                  id
                  opp_id
                }
                transactionLeaseRenter {
                  id
                  opp_id
                }
                transactionLeaseListing {
                  id
                  opp_id
                }
              }
            }
          }
        }
        transactionLeaseRenters {
          items {
            tasks(filter: { assignment_type: { contains: "contact" } }) {
              items {
                id
                task_name
                status
                assignment_type
                type
                due_date
                doc_type {
                  id
                  doc_name
                }
                attachments {
                  id
                  fileId
                  filename
                  downloadUrl
                  shareUrl
                }
                contacts {
                  email
                  first_name
                  last_name
                  id
                  mobile
                }
                internalUserRole {
                  id
                  name
                }
                users {
                  id
                  email
                  lastName
                  firstName
                }
                opportunityBuying {
                  id
                  opp_id
                }
                opportunitySelling {
                  id
                  opp_id
                }
                opportunityLeaseRenter {
                  id
                  opp_id
                }
                opportunityLeaseListing {
                  id
                  opp_id
                }
                transactionBuying {
                  id
                  opp_id
                }
                transactionSelling {
                  id
                  opp_id
                }
                transactionLeaseRenter {
                  id
                  opp_id
                }
                transactionLeaseListing {
                  id
                  opp_id
                }
              }
            }
          }
        }
        transactionLeaseListings {
          items {
            tasks(filter: { assignment_type: { contains: "contact" } }) {
              items {
                id
                task_name
                status
                assignment_type
                type
                due_date
                doc_type {
                  id
                  doc_name
                }
                attachments {
                  id
                  fileId
                  filename
                  downloadUrl
                  shareUrl
                }
                contacts {
                  email
                  first_name
                  last_name
                  id
                  mobile
                }
                internalUserRole {
                  id
                  name
                }
                users {
                  id
                  email
                  lastName
                  firstName
                }
                opportunityBuying {
                  id
                  opp_id
                }
                opportunitySelling {
                  id
                  opp_id
                }
                opportunityLeaseRenter {
                  id
                  opp_id
                }
                opportunityLeaseListing {
                  id
                  opp_id
                }
                transactionBuying {
                  id
                  opp_id
                }
                transactionSelling {
                  id
                  opp_id
                }
                transactionLeaseRenter {
                  id
                  opp_id
                }
                transactionLeaseListing {
                  id
                  opp_id
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const portalUserDocuments = gql`
  query portalUserDocuments($filter: TaskFilter) {
    tasksList(filter: $filter) {
      items {
        id
        task_name
        type
        due_date
        status
        doc_type {
          id
          doc_name
        }
        internalUserRole {
          id
          name
        }
        users {
          id
          email
          lastName
          firstName
        }
        attachments {
          id
          downloadUrl
          filename
          fileId
        }
        contacts {
          id
          email
          first_name
          last_name
          mobile
        }
        assignment_type
        opportunityBuying {
          id
          opp_id
        }
        opportunitySelling {
          id
          opp_id
        }
        opportunityLeaseRenter {
          id
          opp_id
        }
        opportunityLeaseListing {
          id
          opp_id
        }
        transactionBuying {
          id
          opp_id
        }
        transactionSelling {
          id
          opp_id
        }
        transactionLeaseRenter {
          id
          opp_id
        }
        transactionLeaseListing {
          id
          opp_id
        }
      }
    }
  }
`;

export const leadinfoloan = gql`
  query leadinfoloan($id: ID) {
    leadinfoloan(id: $id) {
      id
      lead_provider
      lead_price
      lead_creation_date
      loan_amount
      credit_score
      annual_income
      self_employed
      coBorrower
      first_time_buyer
      bankruptcy
      foreclosure
      military
      down_payment
      debt_to_income
      loan_to_value
      zip_code
      state
      city
      county
      property_type
      property_use
      loan_purpose
      loan_type
      first_mortgage_balance
      second_mortgage_balance
      present_LTV
      proposed_LTV
      lead_id
      legal_first_name
      legal_last_name
      legal_middle_name
      suffix_name
      date_of_birth
      social_security
      current_address
      current_unit
      current_city
      current_state
      current_zip_code
      income
      property_value
      desired_loan
      subject_property_address
      subject_property_state
      subject_property_city
      subject_property_zip_code
      experian
      trans_union
      equifax
      credit_reference
    }
  }
`;

export const leadInfoloanUpdate = gql`
  mutation leadInfoloanUpdate($data: LeadinfoloanUpdateInput!) {
    leadinfoloanUpdate(data: $data) {
      id
    }
  }
`;

export const leadinfoloanCreate = gql`
  mutation leadinfoloanCreate($data: LeadinfoloanCreateInput!) {
    leadinfoloanCreate(data: $data) {
      id
    }
  }
`;

export const loanCreate = gql`
  mutation loanCreate($data: LoanCreateInput!) {
    loanCreate(data: $data) {
      id
    }
  }
`;

export const loansList = gql`
query loansList($filter: LoanFilter) {
  loansList(filter: $filter) {
    items {
      id
      type
      auto_inc
      owner {
        items {
          id
          first_name
          last_name
          email
          __typename
        }
        __typename
      }
      phase {
        id
        stage
        type
        status
        __typename
      }
      desired_purchase_price
      loan_term
      top_priority
      primary_contact{
        id
        loan_officer {
          id
          status
          email
          origin
          firstName
          lastName
          __typename
        }
      	processor{
          id
          status
          email
          origin
          firstName
          lastName
          __typename
        }
      }
      __typename
    }
    __typename
  }
}
`;

export const loansListDetails = gql`
  query loansList($filter: LoanFilter) {
    loansList(filter: $filter) {
      items {
        id
        actual_broker_compensation
        actual_close_date
        application_date
        application_to_CTC
        application_to_close
        application_to_disclosure
        application_to_submission
        appraisal_CR
        appraisal_status
        title_status
        appraised_value
        approval_to_CTC
        approval_to_close
        assets
        auto_inc
        balanced_amount
        ctc_to_close
        cash_out_amount
        clear_to_close_date
        cltv
        compensation
        compensation_type
        conditionally_approved_date
        condo_docs_CR
        contract_close_date
        contract_to_application
        credit
        credit_payments
        credit_report_CR
        credit_report_date
        current_loan_balance
        dti_back
        dti_front
        deletedAt
        denied_date
        deposit_amount
        deposit_date
        desired_PITI
        desired_close_date
        desired_closing_date
        desired_debt_paid
        desired_loan_amount
        desired_purchase_price
        disclosure_date
        down_payment
        escrow
        down_payment_currency
        estimated_CLTV
        estimated_DTI
        estimated_LTV
        estimated_close_date
        estimated_closing_date
        estimated_credit_payments
        estimated_credit_score
        estimated_debts
        estimated_assets
        estimated_home_value
        estimated_income
        estimated_interest_rate
        estimated_loan_type
        executed_contract_date
        expected_compensation
        final_inspection_CR
        funding_date
        gift_funds
        home_insurance_status
        income
        income_month
        initial_CD_issued_date
        initial_CD_status
        interest_rate
        interest_rate_difference
        ltv
        lender
        lender_file_upload_date
        loan_amount
        loan_product
        loan_term
        pre_approval_loan_type
        loan_term_left
        loan_type
        lock_expiration
        lock_extensions
        title_company
        company
        rush_file
        company_paid_for_appraisal
        lender_loan_number
        application_to_Initial_CD
        conditions_at_approval
        mi_rate
        max_pre_approval
        middle_credit_score
        mortgage_insurance
        motivation
        next_follow_up_date
        original_loan_amount
        original_loan_term
        estimated_value
        owner {
          items {
            email
            last_name
            first_name
            mobile
            id
          }
        }
        primary_contact {
          id
          last_name
          first_name
          email
          mobile
        }
        payment_difference
        principal_interest
        property_insurance
        property_occupancy
        property_state
        purchase_price
        qc_issues
        qc_review_date
        re_inspction_CR
        reconciled_bank_date
        reserves
        sale_of_home
        submission_date
        submission_to_approval
        submission_to_close
        submission_to_CTC
        term_difference
        taxes
        tolerance_cure
        title_status
        top_priority
        total_PITI
        total_assets_value
        type
        withdrawn_dated
        income_tab
        debt_tab
        asset_tab
        phase {
          id
          stage
          order
          type
        }
        title_closer_email
        confirmed_closing_date
        appraisal_reimbursed
        final_inspection_reimbursed
        condo_cert_reimbursed
        other_invoices_reimbursed
        seller_concessions
        hoi_to_be_paid_at_close
        gift_to_be_paid_at_close
        statements_for_liabilities_paid_at_close
        uwm_upload_and_accept_all_invoices
        all_invoices_uploaded_in_system
        funding_conditions_notes_for_file
        loanOfficer {
          email
          firstName
          id
          lastName
        }
        processor {
          email
          firstName
          id
          lastName
        }
      }
    }
  }
`;

export const vendorTypesList = gql`
  query vendorTypesList($filter: VendorTypeFilter) {
    vendorTypesList(filter: $filter) {
      items {
        id
        vendor_type
        record_type
      }
    }
  }
`;

export const vendorTypeCreate = gql`
  mutation vendorTypeCreate($data: VendorTypeCreateInput!) {
    vendorTypeCreate(data: $data) {
      id
    }
  }
`;

export const loanUpdate = gql`
  mutation loanUpdate($data: LoanUpdateInput!) {
    loanUpdate(data: $data) {
      id
    }
  }
`;

export const loanDelete = gql`
  mutation loanDelete($data: LoanDeleteInput) {
    loanDelete(data: $data) {
      success
    }
  }
`;

export const vendorAssignmentCreate = gql`
  mutation vendorAssignmentCreate($data: [VendorAssignmentCreateManyInput]!) {
    vendorAssignmentCreateMany(data: $data) {
      items {
        id
      }
    }
  }
`;

export const vendorAssignmentsList = gql`
  query vendorAssignmentsList($filter: VendorAssignmentFilter) {
    vendorAssignmentsList(filter: $filter) {
      items {
        id
        company
        name
        phone
        email
        vendorTypes {
          id
          vendor_type
          record_type
        }
      }
    }
  }
`;

export const vendorAssignmentUpdate = gql`
  mutation vendorAssignmentUpdate($data: VendorAssignmentUpdateInput!) {
    vendorAssignmentUpdate(data: $data) {
      id
    }
  }
`;

export const vendorAssignmentDelete = gql`
  mutation vendorAssignmentDelete($data: VendorAssignmentDeleteInput) {
    vendorAssignmentDelete(data: $data) {
      success
    }
  }
`;

export const contactsListReport = gql`
  query loansList($filter: LoanFilter) {
    loansList(filter: $filter) {
      items {
        phase {
          id
          stage
          __typename
        }
        primary_contact {
          leadinfoloans {
            items {
              id
              legal_first_name
              legal_last_name
              __typename
            }
            __typename
          }
          __typename
        }
        id
        type
        desired_purchase_price
        desired_loan_amount
        estimated_credit_score
        top_priority
        desired_close_date
        next_follow_up_date
        max_pre_approval
        credit
        income
        assets
        sale_of_home
        loan_amount
        interest_rate
        middle_credit_score
        lender
        loan_type
        loan_product
        __typename
      }
      __typename
    }
  }
`;
export const loanProspects = gql`
  query reportListsList {
    reportListsList {
      items {
        id
        name
        phase {
          items {
            id
            stage
          }
        }
      }
    }
  }
`;

export const loanListReport = gql`
  query loansList($filter: LoanFilter) {
    loansList(filter: $filter) {
      items {
        id
        phase {
          id
          stage
        }
        primary_contact {
          leadinfoloans {
            items {
              id
              legal_first_name
              legal_last_name
            }
          }
        }
        type
        id
        loan_amount
        purchase_price
        middle_credit_score
        lock_expiration
        estimated_closing_date
        lender
        loan_type
        loan_product
        compensation_type
        compensation
        appraisal_status
        title_status
        home_insurance_status
        initial_CD_status
        credit_report_date
        executed_contract_date
        application_date
        disclosure_date
        submission_date
        conditionally_approved_date
        initial_CD_issued_date
        clear_to_close_date
        contract_close_date
        estimated_close_date
        actual_close_date
        lender_file_upload_date
        qc_review_date
        deposit_date
        deposit_amount
        balanced_amount
        reconciled_bank_date
      }
    }
  }
`;

export const opportunityContactsListReport = gql`
  query (
    $buyingFilter: OpportunityBuyingFilter
    $sellingFillter: OpportunitySellingFilter
    $leaseRentersFilter: OpportunityLeaseRenterFilter
    $leaseListingsFilter: OpportunityLeaseListingFilter
  ) {
    opportunityBuyingsList(filter: $buyingFilter) {
      items {
        id
        ideal_move_in_date
        cities_searching
        ideal_purchase_price
        max_purchase_price
        loan_officer
        tours
        homes_seen
        offers_made
        broker_agreement_date
        first_offer_date
        first_showing_date
        phase {
          id
          stage
        }
      }
    }
    opportunitySellingsList(filter: $sellingFillter) {
      items {
        id
        subject_city
        appointment_scheduled
        first_offer_date
        showings_received
        offers_received
        total_revenue
        listing_contract_signed_date
        listing_expiration_date
        subject_address_one
        list_price_estimate
        open_house_date

        phase {
          id
          stage
        }
      }
    }
    opportunityLeaseRentersList(filter: $leaseRentersFilter) {
      items {
        id
        ideal_move_in_date
        cities_searching
        broker_agreement_date
        first_offer_date
        first_showing_date

        phase {
          id
          stage
        }
      }
    }
    opportunityLeaseListingsList(filter: $leaseListingsFilter) {
      items {
        id
        subject_city
        appointment_scheduled
        first_offer_date
        showings_received
        offers_received
        total_revenue
        listing_contract_signed_date
        listing_active_date
        listing_expiration_date
        list_price_estimate
        first_open_house

        phase {
          id
          stage
        }
      }
    }
  }
`;

export const transactionsListReport = gql`
  query (
    $buyingFilter: TransactionBuyingFilter
    $sellingFillter: TransactionSellingFilter
    $leaseRentersFilter: TransactionLeaseRenterFilter
    $leaseListingsFilter: TransactionLeaseListingFilter
  ) {
    transactionBuyingsList(filter: $buyingFilter) {
      items {
        id
        subject_address_one
        subject_city
        subject_state
        subject_zip_code
        purchase_price
        inspection_status
        appraisal_status
        loan_status
        close_date
        financing_or_cash
        total_revenue
        under_contract_date

        phase {
          stage
        }
      }
    }
    transactionLeaseListingsList(filter: $leaseListingsFilter) {
      items {
        id
        subject_address_one
        subject_city
        subject_state
        subject_zip_code
        total_revenue
        under_contract_date
        sale_price
        showings_received
        offers_received
        appointment_scheduled_date
        listing_contract_signed_date
        photography_date
        listing_active_date
        lease_signing_date
        lease_expiration_date

        phase {
          stage
        }
      }
    }
    transactionSellingsList(filter: $sellingFillter) {
      items {
        id
        subject_address_one
        subject_city
        subject_state
        subject_zip_code
        inspection_status
        appraisal_status
        loan_status
        under_contract_date
        sale_price
        showings_received
        offers_received
        contract_close_date
        cash_sale
        appointment_scheduled_date
        listing_contract_signed_date
        photography_date
        listing_active_date

        phase {
          stage
        }
      }
    }
    transactionLeaseRentersList(filter: $leaseRentersFilter) {
      items {
        id
        close_date
        total_revenue
        appointment_scheduled_date
        appointment_held_date
        lease_signing_date
        lease_expiration_date

        phase {
          stage
        }
      }
    }
  }
`;

export * from './vehicles';
export * from './drivers';
export * from './maintenance';
// export * from './trips';
export * from './fuelLogs';
